var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-main container" },
    [
      _c("basic-formatter", {
        staticClass: "formatter-layout",
        attrs: {
          mpeFields: _vm.getMpeFields,
          mpeStriped: _vm.getEditedMpe,
          selectedMedia: _vm.getSelectedMedia,
          availableMedia: _vm.availableMedia,
          basic: _vm.basic,
          submitDisabled: _vm.submitDisabled
        },
        on: {
          updateMpePayload: _vm.updateMpePayload,
          updateMpeParams: _vm.updateMpeParams,
          updateMpeMedia: _vm.updateMpeMedia,
          saveChanges: _vm.saveChanges,
          discardChanges: _vm.discardChanges,
          duplicateMpe: _vm.duplicateMpe,
          updatePayload: _vm.updateMpePayload
        },
        scopedSlots: _vm._u(
          [
            {
              key: "above",
              fn: function(ref) {
                var params = ref.params
                return _vm.getMpeType === "twitterTweet"
                  ? _c(
                      "div",
                      { staticClass: "text-right w-100" },
                      [
                        _c("text-counter", {
                          attrs: { textLength: (params.status || "").length },
                          on: {
                            change: function($event) {
                              _vm.submitDisabled = !$event.valid
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-492ac893", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492ac893","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CampaignMpeEditor.vue
// module id = null
// module chunks = 